<template>
  <div v-if="fetchMyProfile">
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Profile" />
    <div class="box">
      <div class="columns is-mobile is-mobile">

        <!--Modal for profile update-->
        <b-modal  
        :active.sync="profileModalActive"
        has-modal-card
        trap-focus
        :destroy-on-hide="true"
        aria-role="dialog"
        aria-modal>
          <set-profile @over="profileModalActive = false"></set-profile>
        </b-modal>

        <div class="column is-2">
          <b-image rounded :src="(fetchMyProfile.profile_picture) ? fetchMyProfile.profile_picture : require('@/assets/images/no-avatar.webp')"></b-image>
        </div>
        <div class="column is-10-tablet is-10-mobile">
          <p class="title is-5">{{fetchMyProfile.name}}</p>
          <b-button @click="profileModalActive = true" size="is-small" type="is-primary" outlined>Edit preferences</b-button>
          <p class="mt-2"><b-icon size="is-small" icon="cellphone"></b-icon> <small>{{fetchMyProfile.mobile}}</small></p>
          <p><b-icon size="is-small" icon="email"></b-icon> <small>{{fetchMyProfile.email}}</small></p>
          <p><b-icon size="is-small" icon="card-text"></b-icon> <small>You have {{fetchMyProfile.no_kids}} kids</small></p>
          <p v-if="fetchMyProfile.introduction"><b-icon size="is-small" icon="card-text"></b-icon><small> {{fetchMyProfile.introduction}}</small></p>
          
        </div>
      </div>
    </div>

    <div class="box">
    
      <b-tabs v-model="current_tab_index" position="is-centered" type="is-toggle">
        <b-tab-item v-for="(kid,i) in fetchMyProfile.no_kids" :key="`KID_TAB_${i}`" :label="`Kid ${i}`" icon="google-photos">
          <div class="columns is-centered">
            <div class="column is-6">
              <set-kid :kid_id="currentKidId" @over="profileModalActive = false"></set-kid>
            </div>
          </div>
        </b-tab-item>
      </b-tabs>

    </div>

  </div>
</template>
<script>
//Vuex
import { mapGetters, mapActions } from "vuex";
// import EmptyTable from '@/components/EmptyTable'
import PageTitle from "@/components/PageTitle";
import SetProfile from "@/components/Profile/SetProfile";
import SetKid from "@/components/Kid/SetKid";

export default {
  name: "Profile",
  components: {
    PageTitle,
    SetProfile,
    SetKid
    // EmptyTable
  },
  data() {
    return {
      isLoading: false,
      profileModalActive : false,
      current_tab_index : 0
    }
  },
  computed: {
    ...mapGetters(["getTeacherToken", "fetchMyProfile"]),
    currentKidId(){
      let id = null
      if(this.fetchMyProfile.kids.length){
        id = this.fetchMyProfile.kids[this.current_tab_index] ? this.fetchMyProfile.kids[this.current_tab_index] : null
      }
      return id
    }
  },
  methods: {
    ...mapActions(["createQuizMaster", "createCandidate", "loadProfile"]),
    
  },
  async created() {
    this.isLoading = true
    await this.loadProfile({ token : this.getTeacherToken })
    this.isLoading = false
  },
};
</script>
<style scoped>
.row-img {
  width: 200px;
}
</style>